"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transform = transform;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
const _excluded = ["icon", "indicator", "onClick", "onKeyDown", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Converts the legacy configuration object into props for <Collapsible/>
 *
 * @param {Object} config - Configuration object
 * @param {Component} indicator - Legacy icon for the component
 * @param {Function} onClick - Legacy onClick callback
 * @param {Function} onKeyDown - Legacy onKeyDown callback
 * @returns {Object} - A converted props object for <Collapsible/>
 */

function transform(config) {
  const {
      icon,
      indicator,
      onClick = Function.prototype,
      onKeyDown = Function.prototype,
      onChange = Function.prototype
    } = config,
    rest = (0, _objectWithoutProperties2.default)(config, _excluded);
  return _objectSpread(_objectSpread({}, rest), {}, {
    icon: icon || indicator,
    onChange: (value, meta) => {
      const {
        event
      } = meta;
      (event.key ? onKeyDown : onClick)(event);
      onChange(value, meta);
    }
  });
}